import Controller from "./notes.controller";
import template from "./notes.html";

const notes = {
  template,
  controller: Controller,
  bindings: {
    title: "@",
    eventName: "<",
    items: "<",
    type: "@",
    emptyMsg: "@",
    permissionName: "@",
    removeAdd: "<",
  },
};

export default notes;



// WEBPACK FOOTER //
// ./src/components/notes/notes.component.js